export default {"src":"/_next/static/media/icon-ga-logo-full-color-filled.3f8367cd.svg","height":32,"width":184,"blurWidth":0,"blurHeight":0};